//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"
export const ADD_NEW_INVOICE = "/add/invoice"
export const UPDATE_INVOICE = "/update/invoice"
export const DELETE_INVOICE = "/delete/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"


export const COUNTRIES = `/country_list`
export const COUNTRIESANDSTATES = `/countries`

// lystface
export const LYSTFACE_VERIFY_USER = `/activation-link`

export const LYSTFACE_SIGNUP_USER = `/signup`
export const LYSTFACE_SIGNUP_RESEND = `/activation-link-resend`
export const LYSTFACE_LOGIN_USER = `/login`
export const LYSTFACE_LOGOUT_USER = `/logout`

export const LYSTFACE_FORGOT_PASSWORD = `/forgotpassword`
export const LYSTFACE_FORGOT_PASSWORD_VERIFY = `/frgtlnkvrfy/`
export const LYSTFACE_FORGOT_PASSWORD_UPDATE = `/forgotpassword/`

export const LYSTFACE_ADD_INTENT = `/payment/addpaymentintent`
export const LYSTFACE_ADD_CARD = `/payment/addpaymentmethod`
export const LYSTFACE_PAYMENT_METHOD_LIST = "/payment/paymentmethods"
export const LYSTFACE_PAYMENT_METHOD_REMOVE = "/payment/removepaymentmethod"
export const LYSTFACE_PAYMENT_METHOD_DEFAULT = "/payment/defaultpaymentmethod"
export const LYSTFACE_PAYMENT_INVOICES = "/invoices"
export const LYSTFACE_COMPANY_ACTIVE_PLAN = "/plan/details"
export const LYSTFACE_ADD_BILL_ADDRESS = "/billaddress/add"
export const LYSTFACE_GET_BILL_ADDRESS = "/billaddress/get"
export const LYSTFACE_EDIT_BILL_ADDRESS = "/billaddress/edit"
export const LYSTFACE_TIMEZONES = `/timezone`

//Home Page
export const LYSTFACE_PLAN_SPECIFICATION_DETAILS = `/plan/details`
export const LYSTFACE_GETSTARTED_SECTION = `/checkStart`
export const LYSTFACE_TRANSACTION_LIMIT = `/transL`



//Application Page
export const LYSTFACE_APPS_LIST = `/app/list`
export const LYSTFACE_CREATE_APP = `/app/create`
export const LYSTFACE_EDIT_APP = `/app/edit`
export const LYSTFACE_REGENERATE_APP_KEY = `/app/regeneratekeys`
export const LYSTFACE_GET_ACCOUNT_SETTING_PROFILE = `/profile`
export const CHANGE_PASSWORD_API = `/reset-password`;
export const EDIT_ACCOUNT_SETTING = `/edit`;
export const LYSTFACE_DELETE_APP = `/app/delete`


//Verification (Email/Phone)
export const LYSTFACE_VERIFY_OTP = `/verifyOtp`
export const LYSTFACE_TWO_FACTOR_AUTH = `/twoFactor`
export const LYSTFACE_RESEND_OTP = `/sendOtp`
export const LYSTFACE_VERIFY_CURRENT_PSWD = `/verify`
export const LYSTFACE_SEND_EMAIL = `/sendEmail`
export const LYSTFACE_UPDATE_CONTACT = `/updateContact`
export const LYSTFACE_VERIFY_LOGIN_OTP = `/verifyLogOtp`
export const LYSTFACE_RESEND_LOGIN_OTP = `/sendLogOtp`
export const LYSTFACE_VERIFY_EMAIL = `/verifyEmail`






// plan page
export const LYSTFACE_PLAN_ADD = "/plan/activate"

//usage
export const USAGE_DETAILS = "/getUsage"

//
export const CONST_DETAILS = "/constants"

//pricing
export const GET_PLANS_LIST = `/planInfo`
export const CANCEL_SUBSCRIPTION = `/plan/cancel`
export const CHECK_PLAN_LIMIT = `/limitCh`
export const GET_ESTIMATION = `/estimate`
export const UPGRADE_PLAN = `/plan/upgrade`
export const DOWNGRADE_PLAN = `plan/downgrade`
export const CANCEL_SCHEDULE = `/cancelSch`







